import axios from "axios";

import { BACKEND_URL, SOURCE_ID } from "../constants"

const validateReport = (visitorId, report) => {
  const url = `${BACKEND_URL}/api/v1/clifton-strengths/reports/`;
  const formData = new FormData();
  formData.append('vid', visitorId);
  formData.append("src", SOURCE_ID);
  formData.append('file', report);
  return axios.post(url, formData);
}

const getReportValidationStatus = (reportId) => {
  const url = `${BACKEND_URL}/api/v1/clifton-strengths/reports/${reportId}/`;
  return axios.get(url);
}

const createOrder = (visitorId, reportIds) => {
  const url = `${BACKEND_URL}/api/v1/orders/`;
  return axios.post(url, {
    vid: visitorId,
    rids: reportIds,
  });
}

const setEmail = (orderId, email) => {
  const url = `${BACKEND_URL}/api/v1/orders/${orderId}/`;
  return axios.patch(url, {
    email: email,
  });
}

const getBundles = () => {
  const url = `${BACKEND_URL}/api/v1/products/bundles/${SOURCE_ID}/`;
  return axios.get(url);
}

const setBundle = (orderId, bundleId) => {
  const url = `${BACKEND_URL}/api/v1/orders/${orderId}/`;
  return axios.patch(url, {
    bid: bundleId,
  });
}

const createPaymentMethod = (stripe, card, nameOnCard) => {
  return stripe.createPaymentMethod({
    type: "card",
    card: card,
    metadata: { nameOnCard },
  });
}

const chargeCard = (visitorId, paymentMethodId, orderId) => {
  const url = `${BACKEND_URL}/api/v1/orders/${orderId}/payment/`;
  return axios.post(url, {
    vid: visitorId,
    pid: paymentMethodId,
  });
}

const confirmCharge = (visitorId, paymentIntentId, orderId) => {
  const url = `${BACKEND_URL}/api/v1/orders/${orderId}/payment/`;
  return axios.patch(url, {
    vid: visitorId,
    pid: paymentIntentId,
  });
}

const claimThinkificDiscountCode = (visitorId, orderId) => {
  const url = `${BACKEND_URL}/api/v1/thinkific/discount-codes/`;
  return axios.post(url, {
    vid: visitorId,
    oid: orderId,
  });
}

export const csServices = {
  validateReport,
  getReportValidationStatus,
  createOrder,
  setEmail,
  getBundles,
  setBundle,
  createPaymentMethod,
  chargeCard,
  confirmCharge,
  claimThinkificDiscountCode,
};